<template>
  <nav
    ref="rootEl"
    class="overflow-auto desktop:overflow-hidden relative z-50 h-[var(--breadcrumb-height)]"
    aria-label="breadcrumbs"
  >
    <ol
      class="flex items-center tablet:py-size-5 h-full"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <li
        v-for="(link, index) in crumbs"
        :key="link.text"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
        class="font-bold breadcrumb-item flex items-center text-size-7 tablet:text-size-6 text-muted whitespace-nowrap leading-none [.has-hero-image_&]:text-white"
      >
        <span
          v-if="index === crumbs.length - 1"
          itemprop="name"
          class="pointer-events-none"
          >{{ link.text }}</span
        >
        <ZtLink
          v-else
          :class="{ 'is-active': index === crumbs.length - 1 }"
          :to="link.url"
          itemprop="item"
          class="hover:text-scheme-invert py-[0.5em]"
        >
          <SpriteSymbol v-if="index === 0" name="home" class="size-[1em]" />
          <span
            itemprop="name"
            :class="{
              'sr-only': index === 0,
            }"
            >{{ link.text }}</span
          >
        </ZtLink>
        <meta itemprop="position" :content="(index + 1).toString()" />
      </li>
    </ol>
  </nav>
</template>

<script lang="ts" setup>
import type { BreadcrumbFragment } from '#graphql-operations'
import { getPathFromUrl } from '~/helpers'

const props = defineProps<{
  links: BreadcrumbFragment[]
}>()

const route = useRoute()
const { isMobile } = useViewport()

const rootEl = ref<HTMLElement>()

const crumbs = computed(() => {
  return props.links
    .map((link, index, arr) => {
      const url = link.url?.path || (index === arr.length - 1 ? route.path : '')
      return {
        url,
        text: link.title || '',
      }
    })
    .filter((v, i, arr) => {
      if (arr[i - 1] && arr[i - 1].url === v.url) {
        return false
      }
      return v.url
    })
    .map((v) => {
      return {
        ...v,
        url: getPathFromUrl(v.url),
      }
    })
})

watch(crumbs, function () {
  nextTick(() => {
    if (!rootEl.value || !isMobile.value) {
      return
    }

    // Scroll to the end of the breadcrumbs on mobile.
    rootEl.value.scrollLeft = 2000
  })
})
</script>
